import type { ValidationErrors } from '@frontend/utils';
import { FinancialReportType } from '@common/enums';
import type { ISearchParams } from '../requestFinancialExportUtils';
import { RequestFinancialExportActivityFilter } from './RequestFinancialExportActivityFilter';
import { RequestFinancialExportPeriodFilter } from './RequestFinancialExportPeriodFilter';
import { RequestFinancialExportServiceFilter } from './RequestFinancialExportServiceFilter';

interface IRequestFinancialExportFiltersProps {
    errors: ValidationErrors;
    financialReportType?: FinancialReportType;
    isDisabled: boolean;
    onChange: (filterName: keyof ISearchParams, value?: string | Date | null) => void;
    searchParams: ISearchParams;
}

export function RequestFinancialExportFilters(props: IRequestFinancialExportFiltersProps) {
    return (
        <>
            <RequestFinancialExportPeriodFilter
                endDate={props.searchParams.endDate}
                errors={props.errors}
                isDisabled={props.isDisabled}
                onChange={props.onChange}
                startDate={props.searchParams.startDate}
            />

            <RequestFinancialExportServiceFilter
                errors={props.errors}
                isDisabled={props.isDisabled}
                onChange={props.onChange}
                searchParams={props.searchParams}
            />

            {props.financialReportType === FinancialReportType.payouts && (
                <RequestFinancialExportActivityFilter
                    activityTypeChoice={props.searchParams.activityTypeChoice}
                    errors={props.errors}
                    isDisabled={props.isDisabled}
                    onChange={props.onChange}
                />
            )}
        </>
    );
}
